module.exports = __webpack_public_path__ + "static/mfw26-e28f42642b03b11c049de6a5e2b5661b.jpg";